export default "__VITE_ASSET__BKEDxgT1__"